import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/bookmarksActions';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import '../../styles/styles.scss';

// 💬 keeping the bubble here just to make sure for cross browser compatibility
const BubbleIcon = () => <span style={{ marginRight: '4px' }}>&#128172;</span>;

export class Menu extends React.Component {
  componentDidMount() {
    this.props.actions.loadBookmarks();
  }

  render() {
    const myUrlWithParams = new URL(window.location.href);
    const selectedBookmark = myUrlWithParams.searchParams.get('bookmark')
      ? myUrlWithParams.searchParams.get('bookmark')
      : 'main';
    return (
      <div className="nav-scroller bg-white shadow-sm">
        <nav className="nav nav-underline" style={{ marginTop: '3px' }}>
          <a
            href="/feedback?bookmark=main"
            className={
              selectedBookmark === 'main' ? 'nav-link activeLink' : 'nav-link'
            }
          >
            <BubbleIcon />
            <FormattedMessage
              id="app.menu.feedbacks"
              defaultMessage="Feedbacks"
            />
          </a>
          <a
            href="/feedback?bookmark=skoda"
            className={
              selectedBookmark === 'skoda' ? 'nav-link activeLink' : 'nav-link'
            }
          >
            <BubbleIcon />
            <FormattedMessage
              id="app.menu.feedbacks.skoda"
              defaultMessage="Feedbacks"
            />
          </a>
          <a
            href="/feedback?bookmark=cz"
            className={
              selectedBookmark === 'cz' ? 'nav-link activeLink' : 'nav-link'
            }
          >
            <BubbleIcon />
            <FormattedMessage
              id="app.menu.feedbacks.market.czech"
              defaultMessage="Feedbacks"
            />
          </a>
          <a
            href="/feedback?bookmark=sk"
            className={
              selectedBookmark === 'sk' ? 'nav-link activeLink' : 'nav-link'
            }
          >
            <BubbleIcon />
            <FormattedMessage
              id="app.menu.feedbacks.market.slovakia"
              defaultMessage="Feedbacks"
            />
          </a>
          {this.props.bookmarks &&
            this.props.bookmarks.map((bookmark, i) => (
              <a
                key={'bookmark' + i}
                href={'/feedback?bookmark=' + bookmark.id}
                className={
                  selectedBookmark === bookmark.id
                    ? 'nav-link activeLink'
                    : 'nav-link'
                }
              >
                💬 {bookmark.name}{' '}
              </a>
            ))}
          {/* {this.props.userRole === 'ROLE_CARFEEDBACK_ADMINS' && <a href="/bookmarks" className="nav-link"> ✏ </a>} */}
          {/* <NavLink exact to="/rating" className="nav-link">⭐ Hodnocení aplikace</NavLink> */}
        </nav>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.bookmarks.loading,
    error: state.bookmarks.error,
    bookmarks: state.bookmarks.bookmarks,
    users: state.bookmarks.users,
  };
}

Menu.propTypes = {
  actions: PropTypes.object.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  bookmarks: PropTypes.array,
  users: PropTypes.array,
  userRole: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
